export default __webpack_public_path__ + "static/refill-c25c6037f142bd0e6123a4bda935cf99.png";